<template>
  <v-app-bar
    v-if="!$vuetify.breakpoint.mobile"
    app
    outlined
    flat
    style="background-color: white"
  >
    <!-- <div class="d-flex align-center">
      <v-app-bar-nav-icon @click="toggleDrawer"></v-app-bar-nav-icon>
    </div> -->

    <slot></slot>

    <v-spacer></v-spacer>

    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-badge overlap color="" offset-x="20" offset-y="20">
          <template #badge>
            <router-link
              to="/docs/about_apk"
              style="text-decoration: none; color: inherit"
            >
              <v-icon
                style="font-size: 16px; color: goldenrod"
                title="Подробнее"
              >
                mdi-information-outline
              </v-icon>
            </router-link>
          </template>
          <v-btn icon link href="/static/apk/3trash.apk" v-on="on">
            <v-icon>mdi-package-variant-closed</v-icon>
          </v-btn>
        </v-badge>
      </template>
      <span>Скачать APK</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-btn
          icon
          link
          href="https://play.google.com/store/apps/details?id=com.trashRsoft"
          target="_blank"
          v-on="on"
        >
          <v-icon>mdi-google-play</v-icon>
        </v-btn>
      </template>
      <span>Скачать в Google&nbsp;Play</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-btn
          icon
          link
          href="https://apps.apple.com/ru/app/%D0%B2%D1%82%D0%BE%D1%80%D1%8D%D0%BA%D0%BE%D1%80%D0%B5%D1%81%D1%83%D1%80%D1%81/id1658263610"
          target="_blank"
          v-on="on"
        >
          <v-icon>mdi-apple</v-icon>
        </v-btn>
      </template>
      <span>Скачать в App&nbsp;Store</span>
    </v-tooltip>

    <span v-if="authorised">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-badge
            :content="notification_count"
            :value="notification_count > 0"
            offset-x="20"
            offset-y="20"
            overlap
            color="red"
          >
            <v-btn icon link to="/notifications" v-on="on">
              <v-icon>mdi-bell-outline</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <span>Уведомления</span>
      </v-tooltip>
    </span>

    <span v-if="authorised">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-badge
            :content="payed_count"
            :value="payed_count > 0"
            offset-x="20"
            offset-y="20"
            overlap
            color="red"
          >
            <v-btn icon link to="/payed_orders" v-on="on">
              <v-icon>mdi-currency-rub</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <span>Оплаченные заказы</span>
      </v-tooltip>
    </span>

    <span v-if="authorised">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-badge
            :content="messages_count"
            :value="messages_count > 0"
            offset-x="20"
            offset-y="20"
            overlap
            color="red"
          >
            <v-btn icon link to="/messages" v-on="on">
              <v-icon>mdi-message-outline</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <span>Сообщения</span>
      </v-tooltip>
    </span>

    <v-tooltip v-if="!authorised" bottom>
      <template #activator="{ on }">
        <v-btn icon link to="/login" v-on="on">
          <v-icon>mdi-location-enter</v-icon>
        </v-btn>
      </template>
      <span>Войти</span>
    </v-tooltip>

    <v-tooltip v-if="authorised" bottom>
      <template #activator="{ on }">
        <v-btn icon link to="/logout" v-on="on">
          <v-icon>mdi-location-exit</v-icon>
        </v-btn>
      </template>
      <span>Выйти</span>
    </v-tooltip>

    <v-tooltip v-if="!authorised" bottom>
      <template #activator="{ on }">
        <v-btn icon link to="/register" v-on="on">
          <v-icon>mdi-account-plus-outline</v-icon>
        </v-btn>
      </template>
      <span>Зарегистрироваться</span>
    </v-tooltip>
  </v-app-bar>
</template>

<script>
import { useStore } from "@/store";

const store = useStore();

export default {
  name: "AppToolbar",
  props: {
    authorised: Boolean,
    side_menu_visible: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    notification_count() {
      return store.pending_orders.orders.length;
    },
    payed_count() {
      return store.payed_orders.orders.length;
    },
    messages_count() {
      return store.messages.length;
    },
  },
  methods: {
    toggleDrawer() {
      this.$emit("update:side_menu_visible", !this.side_menu_visible);
    },
  },
};
</script>
